import { xzLocal, xzSession } from '../../until/common';
import {
  USERINFO,
  USERSTATUS,
  USERTOKEN,
  USERMEMBERCENTER,
  MEMBERORDERLIST,
  COUPONS,
  LOGINOUT,
  WALLETBANK,
  FLOWFILTERING,
  CURRENCYLIST,
} from '../mutation-type';

const state = {
userToken: xzLocal.get('userToken') || '',
  userInfo: {},
  userStatus: {},
  userMemberCenter: {},
  memberOrderList: {},
  walletBank: [],
  coupons: {},
  flowFiltering: {},
  payType: {},
  currencyTypeList: [],
...(localStorage.getItem('ehammer.state') ? JSON.parse(localStorage.getItem('ehammer.state')).user : {}),
};

const mutations = {
  [USERINFO]: (s, userInfo) => {
    console.log('USERINFO', s, userInfo);
    Object.assign(s.userInfo, userInfo);
  },
  [USERSTATUS]: (s, userStatus) => {
    Object.assign(s.userStatus, userStatus);
    localStorage.userStatus = JSON.stringify(s.userStatus);
  },
  [USERTOKEN]: (s, userToken) => {
    const copy = s;
    copy.userToken = userToken;
    localStorage.userToken = userToken;
  },
  [USERMEMBERCENTER]: (s, userMemberCenter) => {
    console.log('userMemberCenter:', userMemberCenter);
    Object.assign(s.userMemberCenter, userMemberCenter);
  },
  [MEMBERORDERLIST]: (s, memberOrderList) => {
    console.log('memberOrderList:', memberOrderList);
    Object.assign(s.memberOrderList, memberOrderList);
  },
  [WALLETBANK]: (s, walletBank) => {
    s.walletBank = walletBank;
  },
  [COUPONS]: (s, coupons) => {
    Object.assign(s.coupons, coupons);
  },
  [LOGINOUT]: (s) => {
    console.log('LOGINOUT');
    s.userInfo = {};
    s.userToken = '';
    xzLocal.remove('userToken');
  },
  [CURRENCYLIST]: (s, list) => {
    s.currencyTypeList = list;
  },
  [FLOWFILTERING]: (s, flowFiltering) => {
    Object.assign(s.flowFiltering, flowFiltering);
  },

};

export default {
  state,
  mutations,
};
